import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import type { InteractionFormItem } from '../../contactSchema';
import { defaultFormValues, interactionTypeEnum } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const titleCase = (s: string) => (s ? s[0].toUpperCase() + s.slice(1) : s);

const TYPE_OPTIONS = [
  { value: '', label: '—' },
  ...interactionTypeEnum.options
    .filter((v) => v !== '')
    .map((v) => ({ value: v, label: titleCase(v) })),
];

const empty = (): InteractionFormItem => ({});

export const InteractionsSection = withForm({
  defaultValues: defaultFormValues,
  render: function InteractionsSection({ form }) {
    return (
      <SectionCard
        title="Interactions"
        actions={<AddItemButton onClick={() => form.pushFieldValue('interactions', empty())} />}
      >
        <form.AppField name="interactions">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove interaction">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`interactions[${i}].type`}>
                        {(f) => <f.Select label="Type" options={TYPE_OPTIONS} />}
                      </form.AppField>
                      <form.AppField name={`interactions[${i}].subject`}>
                        {(f) => <f.TextField label="Subject" />}
                      </form.AppField>
                    </div>
                    <form.AppField name={`interactions[${i}].summary`}>
                      {(f) => <f.TextField label="Summary" multiline rows={2} />}
                    </form.AppField>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`interactions[${i}].occurredAt`}>
                        {(f) => <f.DatePicker label="Occurred at" />}
                      </form.AppField>
                      <form.AppField name={`interactions[${i}].outcome`}>
                        {(f) => <f.TextField label="Outcome" />}
                      </form.AppField>
                    </div>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
